
import * as Inovx from '@shared';
import assign from 'object-assign';
import { apiPostForm } from '@shared/api/apiClient';
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var DateTimeOffsetHelper = Inovx.Shared.Common.DateTimeOffsetHelper;
var url = `${UrlUtilities.getApiUrl()}/FacilityApi/api/KnowledgeView`;

var KnowledgeViewServices: IKnowledgeViewServices = assign({}, Inovx.Shared.Flux.BaseService, {    
    getKnowledgeViews: function (knowledgeBookID: string) {
        return new Promise<IKnowledgeView[]>((resolve, reject) => {
            this.get(`${url}/ByKnowledgeBook`,
                { knowledgeBookID: knowledgeBookID },
                (retData: IKnowledgeView[]) => {
                    resolve(retData)
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    getKnowledgeView: function (id: string) {
        return new Promise<IKnowledgeView>((resolve, reject) => {
            this.get(`${url}/ById`,
                { id },
                (retData: IKnowledgeView) => {
                    resolve(retData)
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    getKnowledgeViewDetail: function (id: string) {
        return new Promise<IKnowledgeViewDetailResponse>((resolve, reject) => {
            this.get(`${url}/Detail`,
                { id },
                (retData: IKnowledgeViewDetailResponse) => {
                    resolve(retData)
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    createKnowledgeView: function (kv: IKnowledgeView | FormData) {
        var clientTime = DateTimeOffsetHelper.getCurrentDatetimeWithOffset();
        return new Promise<IKnowledgeView>((resolve, reject) => {
            apiPostForm<IKnowledgeView>(`${url}/Create?clientTime=${encodeURIComponent(clientTime)}`, kv as FormData, { responseType: 'json' })
                .then((result: IKnowledgeView) => {
                    resolve(result);
                })
                .catch((error: any) => {
                    this.handleWebApiError(error);
                    reject(error);
                });

        });
    },
    updateKnowledgeView: function (kv: IKnowledgeViewDetail) {
        var clientTime = DateTimeOffsetHelper.getCurrentDatetimeWithOffset();
        return new Promise<IKnowledgeView>((resolve, reject) => {
            this.post(`${url}/Update?clientTime=${encodeURIComponent(clientTime)}`,
                kv,
                (data: any) => {
                    resolve(data);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });

    },
    setKnowledgeViewProperties: function (kv: IKnowledgeView | FormData) {
        var clientTime = DateTimeOffsetHelper.getCurrentDatetimeWithOffset();
        return new Promise<IKnowledgeView>((resolve, reject) => {
            apiPostForm<IKnowledgeView>(`${url}/SetProperties?clientTime=${encodeURIComponent(clientTime)}`, kv as FormData, { responseType: 'json' })
                .then((result: IKnowledgeView) => {
                    resolve(result);
                })
                .catch((error: any) => {
                    this.handleWebApiError(error);
                    reject(error);
                });

        });
    },
    updateKnowledgeViewDetails: function (kv: IKnowledgeView | FormData) {
        var clientTime = DateTimeOffsetHelper.getCurrentDatetimeWithOffset();
        return new Promise<IKnowledgeView>((resolve, reject) => {
            apiPostForm<IKnowledgeView>(`${url}/Update?clientTime=${encodeURIComponent(clientTime)}`, kv as FormData, { responseType: 'json' })
                .then((result: IKnowledgeView) => {
                    resolve(result);
                })
                .catch((error: any) => {
                    this.handleWebApiError(error);
                    reject(error);
                });

        });
    },
    deleteKnowledgeView: function (kv: IKnowledgeView) {
        var clientTime = DateTimeOffsetHelper.getCurrentDatetimeWithOffset();
        return new Promise<void>((resolve, reject) => {
            this.post(`${url}/Delete?clientTime=${encodeURIComponent(clientTime)}`,
                { ID: kv.ID, VersionToken: kv.VersionToken },
                () => {
                    resolve();
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
});

export default KnowledgeViewServices;
